module.exports = "<template>\n    <div>\n        <vbl-nav>\n            <vbl-nav-item to=\"/vblNav\">首页</vbl-nav-item>\n            <vbl-nav-item to=\"/detail\">详情页</vbl-nav-item>\n            <vbl-nav-item to=\"/edit\">编辑</vbl-nav-item>\n        </vbl-nav>\n    </div>\n</template>\n\n<script>\nexport default {\n};\n</script>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/vblNav/example/vblNavExample.vue
// module id = 172
// module chunks = 0